
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  feedback: true,
  toc: true,
  layout: 'guide',
  maxTocLevel: 4,
  skipLLM: true,
  description: "Use VoPay with Plaid Auth to send and receive payments"
};
export const partnerProps = {
  partner: 'VoPay',
  clientLibrary: 'vopay',
  subtitle: metadata.description,
  registrationUrl: 'https://vopay.com/plaid/',
  apiUrl: 'https://docs.vopay.com/reference/getting-started-with-your-api',
  isPaymentProcessor: true
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p><a parentName="p" {...{
        "href": "https://vopay.com/"
      }}>{`VoPay`}</a>{` is a leader in payment innovation, digitizing direct bank payments with speed
and transparency. The VoPay Platform enhances how digital platforms initiate and accept financial transactions
using a single, open API. The company has one goal: to eliminate all payment inefficiencies, so businesses
can focus on what they do best in today’s fast-paced digital economy. VoPay’s EFT / ACH payment service
adds a layer of data intelligence to EFT / ACH transactions to make them instant. With the Plaid
integration, VoPay will validate and authenticate bank account information at the time of the transaction`}</p>
    <p>{`To get started sign up for `}<a parentName="p" {...{
        "href": "https://dashboard.plaid.com/developers/keys"
      }}>{`Plaid API keys`}</a>{`.`}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.AuthIdentityInstructions {...partnerProps} />
    <Partnership.Server {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.Conclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
